import { createContext, useState, useCallback, useMemo } from 'react';
import { type Waypoint } from 'react-waypoint';

type ContextType = {
  isStickySearchBar: boolean;
  handleStickyTransition: ({
    currentPosition,
    previousPosition
  }: Waypoint.CallbackArgs) => void;
};

const defaultContext: ContextType = {
  isStickySearchBar: false,
  handleStickyTransition: () => {}
};

export const StickySearchContext = createContext<ContextType>(defaultContext);

export default function StickySearchProvider({ children }) {
  const [isStickySearchBar, setStickySearchBar] = useState(false);

  const handleStickyTransition = useCallback(
    ({ currentPosition, previousPosition }: Waypoint.CallbackArgs) => {
      const input = document.querySelector<HTMLInputElement>(
        '#merch-search-bar-input'
      );

      if (input) {
        input.blur();
      }

      if (currentPosition === 'above' && previousPosition === 'inside') {
        setStickySearchBar(true);
      }
      if (currentPosition === 'inside' && previousPosition === 'above') {
        setStickySearchBar(false);
      }
    },
    []
  );

  const value = useMemo(
    () => ({
      handleStickyTransition,
      isStickySearchBar
    }),
    [handleStickyTransition, isStickySearchBar]
  );

  return (
    <StickySearchContext.Provider value={value}>
      {children}
    </StickySearchContext.Provider>
  );
}
